"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _absoluteUrlRuntime = require("@insided/shared/utils/absoluteUrlRuntime");

var _Button = _interopRequireDefault(require("../../control-components/ui-components/Button"));

var Unsubscribe = function Unsubscribe(_ref) {
  var phrases = _ref.phrases;
  return (0, _preact.h)("div", {
    className: "unsubscribe-wrapper"
  }, (0, _preact.h)("div", {
    className: "unsubscribe-title"
  }, phrases.title), (0, _preact.h)("div", {
    className: "unsubscribe-body"
  }, phrases.body), (0, _preact.h)("div", {
    className: "unsubscribe-action"
  }, (0, _preact.h)("a", {
    href: (0, _absoluteUrlRuntime.resolveUrl)("/")
  }, (0, _preact.h)(_Button.default, {
    primary: true,
    title: phrases.button
  }))));
};

var _default = Unsubscribe;
exports.default = _default;